module.exports = __webpack_public_path__ + "static/iPhone-1-97e38aff83f633b074c42a404a60e3ba.png";